import { Row, Col } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, Route, Routes, Outlet } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { setPopup } from "./Redux/PopupSlice";
import { useEffect, useRef } from "react";
import "./App.css";
import Footer from "./Components/Footer/Footer";
import Conversation from "./Components/Conversation/Conversation";
import Notification from "./Components/Notification/Notification";
import Message from "./Components/Conversation/Message/Message";
import Group from "./Components/Conversation/Group/Group";
import Header from "./Components/Header/Header";
import Overview from "./Components/Admin/Overview/Overview";
import UserList from "./Components/Admin/UserList/UserList";
import ContentList from "./Components/Admin/ContentList/ContentList";
import Monetization from "./Components/Admin/Monetization/Monetization";
import TrackTime from "./Services/TrackTime.service";
import Home from "./Pages/Home/Home";
import Personal from "./Pages/Personal/Personal";
import MetadataDetail from "./Pages/MetadataDetail/MetadataDetail";
import AdminDashboard from "./Pages/Admin/AdminDashboard";
import Search from "./Pages/Search/Search";

import CensorPage from "./Pages/Censor/CensorPage";
import OverviewForCensor from "./Components/Censor/Overview/OverviewForCensor";
import ModerationsLog from "./Components/Censor/ModerationsLog/ModerationsLog";
import ReportView from "./Components/Censor/ReportView/ReportView";

import GoogleAuthCallback from "./Components/GoogleAuthCallback/GoogleAuthCallback";

const ProtectedRoutes = () => {
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  if (!userInfo) return <Navigate to="/" replace={true} />;
  return <Outlet />;
};

function App() {
  const dispatch = useDispatch();
  const popupSelector = useSelector((state) => state.popup);
  const chatSpaceSelector = useSelector((state) => state.chatSpace);
  const showFooterSelector = useSelector((state) => state.audio.showFooter);
  const popupRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        dispatch(setPopup(null));
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="App">
      <Header />
      <ToastContainer />
      <TrackTime />
      <Row className="bodyWrapper">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route
            path="/playlists/:metadataId"
            element={<MetadataDetail isAudioList={true} />}
          />
          <Route
            path="/trackDetail/:trackId"
            element={<MetadataDetail isAudioList={false} />}
          />
          <Route path="/search" element={<Search />} />
          <Route path="/auth/callback" element={<GoogleAuthCallback />} />

          <Route element={<ProtectedRoutes />}>
            {/* Nếu có route nào mà cần phải đăng nhập mới được truy cập thì ném vào đây */}
            <Route path="/profile/:userId" element={<Personal />} />
          </Route>
        </Routes>

        <Routes>
          <Route path="/admin" element={<AdminDashboard />}>
            <Route path="/admin/overview" element={<Overview />} />
            <Route path="/admin/userList" element={<UserList />} />
            <Route path="/admin/contentList" element={<ContentList />} />
            <Route path="/admin/monetization" element={<Monetization />} />
          </Route>
        </Routes>

        <Routes>
          <Route path="/censor" element={<CensorPage />}>
            <Route path="overview" element={<OverviewForCensor />} />
            <Route path="moderations_log" element={<ModerationsLog />} />
            <Route path="report/:reportId" element={<ReportView />} />
          </Route>
        </Routes>

        {popupSelector !== null && (
          <Col className="popupSpace" ref={popupRef}>
            {popupSelector === "message" ? <Conversation /> : <Notification />}
          </Col>
        )}
        {chatSpaceSelector.open !== null && (
          <Col
            className="chatBoxSpace"
            style={{ bottom: `${showFooterSelector ? "60px" : "0px"}` }}
          >
            {chatSpaceSelector.open === "message" ? <Message /> : <Group />}
          </Col>
        )}
      </Row>
      {showFooterSelector && <Footer />}
    </div>
  );
}

export default App;
